export default __webpack_public_path__ + "static/media/duplicate-tas.6a60c0d1.svg";